import * as React from 'react';
import { FAB } from 'react-native-paper';
import i18n from 'i18n-js';

import { Group } from './group';
import Sequence, {
  label as sequenceLabel,
  icon,
  setting as sequence
} from '../constants/sequence';
import Filter, { isEmpty, label as filterLabel } from '../constants/filter';
import { defaults } from '../constants/settings';

export interface Props {
  filter: Filter;
  sort: Sequence;
  onFilter: () => void;
  onRemoveFilter: () => void;
  onSort: () => void;
}

const Dashboard = (props: Props) => {
  const { filter, sort, onFilter, onRemoveFilter, onSort } = props;

  const [options, setOptions] = React.useState({ open: false } as Group);
  const onOptionsChange = ({ open }: Group) => setOptions({ open });
  const { open } = options;

  const actions = [
    {
      icon: icon(sort) as string,
      label: i18n.t(sequenceLabel(sort || defaults()[sequence])),
      onPress: onSort
    },
    {
      icon: 'filter-plus-outline',
      label: filterLabel(filter) || i18n.t('Unfiltered'),
      onPress: onFilter
    }
  ];

  if (!isEmpty(filter))
    actions.splice(1, 0, {
      icon: 'filter-remove-outline',
      label: i18n.t('Remove'),
      onPress: onRemoveFilter
    });

  return (
    <FAB.Group
      key="FAB"
      open={open}
      visible
      icon={open ? 'view-dashboard' : 'view-dashboard-outline'}
      actions={actions}
      onStateChange={onOptionsChange}
      onPress={() => {
        if (open) {
          // do something
        }
      }}
    />
  );
};

export default Dashboard;
